import React, { useState } from "react";
import { Form, Select, Input, DatePicker, Empty } from "antd";
import moment from "moment";
import { get } from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerLib from "react-datepicker";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const dateValues = {
  Today: dayjs(new Date()),
};

const RenderFilterFields = ({
  filtersData = [],
  onFieldChange = () => {},
  setFilterQueryParams = () => {},
  dateRangeError = false,
  setDateRangeError = () => {},
  dateRangeErrorMessage = "",
  setDateRangeErrorMessage = () => {},
  disabledDate = () => {},
}) => {
  const getStartOfMonth = moment().startOf("month").toDate();
  const [dateValue, setDateValue] = useState(getStartOfMonth);
  const [filterDateRange, setFilterDateRange] = useState([null, null]);

  const formatDate = (date) =>
    date ? moment(date).format("YYYY-MM-DD") : null;

  const [form] = Form.useForm();

  const handleChange = (value, filterCode, filterType) => {
    if (filterCode === "empType") {
      // Clear "name" and "reporting manager" fields when "empType" changes
      form.setFieldsValue({
        agentUserId: null,
        agentRmUserId: null,
      });
      onFieldChange("agentUserId", null);
      onFieldChange("agentRmUserId", null);
      setFilterQueryParams((prevParams) => ({
        ...prevParams,
        empType: value,
        agentUserId: null,
        agentRmUserId: null,
      }));
    }

    if (filterType === "multi_date_picker") {
      const date1 = get(value, "[0]", null);
      const date2 = get(value, "[1]", null);
      setFilterDateRange(value);
      onFieldChange("startDate", date1);
      onFieldChange("endDate", date2);
    } else if (filterType === "date") {
      const formattedDate = formatDate(value);
      setDateValue(value);
      onFieldChange(filterCode, formattedDate);
    } else {
      onFieldChange(filterCode, value);
    }
  };

  const getOptions = (filter) => {
    return filter.filter_values?.filter(Boolean).map((val, index) => ({
      label: val.value,
      value: val.code,
      key: `${val.code}-${index}`,
    }));
  };

  return (
    <>
      {filtersData.length === 0 ? (
        <Empty description="No filters available" />
      ) : (
        filtersData.map((filter) => {
          switch (filter.filter_type) {
            case "code_name_spinner":
              return (
                <Form.Item
                  key={filter.filter_code}
                  label={filter.filter_title}
                  name={filter.filter_code}
                  initialValue={filter.default_filter_value}
                  rules={
                    filter.filter_code === "empType"
                      ? [
                          {
                            required: true,
                            message: "Please select an employee type",
                          },
                        ]
                      : []
                  }
                >
                  <Select
                    allowClear
                    mode={filter.is_single_select ? undefined : "multiple"}
                    options={getOptions(filter)}
                    placeholder={`Select ${filter.filter_title}`}
                    defaultValue={filter.default_filter_value}
                    onChange={(value) =>
                      handleChange(
                        value,
                        filter.filter_code,
                        filter.filter_type
                      )
                    }
                    showSearch
                    notFoundContent={
                      filter.filter_values?.length ? null : (
                        <Empty description="No options available" />
                      )
                    }
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              );

            case "text":
              return (
                <Form.Item
                  key={filter.filter_code}
                  name={filter.filter_code}
                  label={filter.filter_title}
                >
                  <Input
                    placeholder={`Enter ${filter.filter_title}`}
                    onChange={(e) =>
                      handleChange(
                        e.target.value,
                        filter.filter_code,
                        filter.filter_type
                      )
                    }
                  />
                </Form.Item>
              );

            case "date":
              return (
                <Form.Item
                  key={filter.filter_code}
                  name={filter.filter_code}
                  label={filter.filter_title}
                  initialValue={moment(getStartOfMonth).format("YYYY-MM-DD")}
                  rules={[
                    {
                      required: true,
                      message: `Please select ${filter.filter_title}`,
                    },
                  ]}
                >
                  <DatePickerLib
                    selected={dateValue}
                    onChange={(date) =>
                      handleChange(date, "incentiveMonthDate", "date")
                    }
                    className="px-4 py-2 react-calender-input"
                    calendarIconClassname="mt-1"
                    dateFormat="MM/yyyy"
                    showIcon
                    showMonthYearPicker
                    placeholderText="Select Month"
                  />
                </Form.Item>
              );

            case "multi_date_picker":
              return (
                <Form.Item
                  key={filter.filter_code}
                  name={filter.filter_code}
                  label={filter.filter_title}
                  validateStatus={dateRangeError ? "error" : ""}
                  help={dateRangeError ? dateRangeErrorMessage : ""}
                  initialValue={[
                    dateValues[filter.default_filter_value[0]],
                    dateValues[filter.default_filter_value[1]],
                  ]}
                >
                  <RangePicker
                    placeholder={["Start Date", "End Date"]}
                    format="YYYY-MM-DD"
                    className="w-100"
                    onChange={(dates, dateStrings) => {
                      handleChange(
                        dateStrings,
                        filter.filter_code,
                        filter.filter_type
                      );
                      setDateRangeError(false);
                      setDateRangeErrorMessage("");
                    }}
                    disabledDate={disabledDate}
                    defaultValue={[
                      dateValues[filter.default_filter_value[0]],
                      dateValues[filter.default_filter_value[1]],
                    ]}
                  />
                </Form.Item>
              );

            default:
              return null;
          }
        })
      )}
    </>
  );
};

export default RenderFilterFields;
